<template>
    <departmentsComp />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue'

const departmentsComp = defineAsyncComponent(() => import('@/components/managementPages/dapartmentsPage/departmentsComp.vue'))
</script>